<template>
  <div>
    <el-row class="form-item">
      <el-col :span="3"><span class="required-text">*</span>选择预算</el-col>
      <el-col :span="21">
        <el-radio-group v-model="activeBtn" class="radio-btn">
          <!-- <el-radio-button label="pocm">
            <i class="iconfont iconzu91" v-if="activeBtn === 'pocm'" />
            <span v-if="itemType !== '03'">区域POCM预算</span>
            <span v-else>区域Non-Menu预算</span>
          </el-radio-button>
          <el-select v-model="queryFrom.quotaId" placeholder="请选择" v-if="activeBtn === 'pocm'" size="small" @change="setValue" clearable>
            <el-option v-for="item in pocmList" :key="item.quotaDTO.quotaId" :label="item.quotaDTO.quotaName" :value="item.quotaDTO.quotaId" />
          </el-select> -->
          <!-- TR预算 -->
          <el-radio-button label="tr"> <i class="iconfont iconzu91" v-if="activeBtn === 'tr'" />TR预算 </el-radio-button>
          <el-select v-model="queryFrom.quotaId" filterable placeholder="请选择" style="width:350px;" v-if="activeBtn === 'tr'" @change="changeTr" clearable>
            <el-option v-for="(item,index) in trList" :key="index" :label="`${item.trKhCode}-${item.orgName}`" :value="item.quotaId" />
          </el-select>
        </el-radio-group>

        <!-- <el-input placeholder="请填写TR Code" v-if="activeBtn === 'tr'" class="input-round" v-model="trKhCode" @input="inputTr">
          <i slot="suffix" v-if="trVer.show && trVer.success" class="el-input__icon el-icon-success" style="color: #21BA45"></i>
          <i slot="suffix" v-if="trVer.show && !trVer.success" class="el-input__icon el-icon-error" style="color: #C8102D"></i>
        </el-input>
        <el-button class="btn-blue" v-if="activeBtn === 'tr'" size="small" :loading="trLoading" @click="getTrInfo">点击验证</el-button> -->
      </el-col>

    </el-row>
    <el-row class="form-item company-select">
      <el-col :span="3" v-if="hasCompany"><span class="required-text">*</span>选择工厂</el-col>
      <el-col :span="8" v-if="hasCompany">
        <el-select v-model="childCompanyEntityId" placeholder="选择工厂" clearable filterable @change="companySelect">
          <el-option v-for="item in entityList" :label="item.entityCode + '-' + item.entityName" :value="item.entityId" :key="item.entityId" />
        </el-select>
      </el-col>
      <el-col :span="3"><span class="required-text">*</span>选择成本中心</el-col>
      <el-col :span="10">
        <el-input placeholder="请填写成本中心Code" class="input-prepend" v-model="queryFrom.costCenterCode" @input="InputCost">
          <i slot="suffix" v-if="costVer.show && costVer.success" class="el-input__icon el-icon-success" style="color: #21BA45"></i>
          <i slot="suffix" v-if="costVer.show && !costVer.success" class="el-input__icon el-icon-error" style="color: #C8102D"></i>
        </el-input>
        <el-button class="btn-blue" size="small" style="margin-left: 15px" :loading="costLoading" @click="getCostInfo">点击验证</el-button>
      </el-col>
      <!-- <el-col :span="3" v-if="!hasCompany"><span class="required-text">*</span>选择采购组织</el-col>
      <el-col :span="8" v-if="!hasCompany">
        <el-select v-model="queryFrom.purchaseOrg" placeholder="选择采购组织" class="org-select" clearable @change="setValue">
          <el-option
            v-for="item in orgList"
            :key="item.value"
            :label="item.value"
            :value="item.key">
          </el-option>
        </el-select>
      </el-col> -->
    </el-row>
    <!-- <el-row class="form-item company-select" v-if="hasCompany">
      <el-col :span="3"><span class="required-text">*</span>选择采购组织</el-col>
      <el-col :span="8">
        <el-select v-model="queryFrom.purchaseOrg" placeholder="选择采购组织" class="org-select" clearable @change="setValue">
          <el-option
            v-for="item in orgList"
            :key="item.value"
            :label="item.value"
            :value="item.key">
          </el-option>
        </el-select>
      </el-col>
    </el-row> -->
    <el-dialog :visible.sync="quotaDialogVisible" width="50%" title="选取配额">
      <el-table :data="quotaList">
        <el-table-column prop="quotaName" label="配额名称"></el-table-column>
        <el-table-column prop="availableQuota" label="可用配额"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-blue" size="small" @click="handleCheckTrCode(scope.row)">选取</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button class="btn-red" @click="quotaDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseApi from '@/api/base'
import { mapState } from 'vuex'
export default {
  name: 'item-order-picker',
  props: {
    itemType: {
      type: String,
      default: ''
    },
    hasCompany: {
      type: Boolean,
      default: false
    },
    companyEntityId: {
      type: String,
      default: ''
    },
    orderItemList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    ...mapState({
      // orgList: state => state.base.purchaseOrgMap
    })
  },
  data () {
    return {
      trLoading: false,
      costLoading: false,
      activeBtn: 'tr',
      trKhCode: '',
      queryFrom: {
        trKhCode: '',
        // entityId: '',
        quotaId: '',
        // entityCode: '',
        costCenterCode: '',
        costCenterId: '',
        budget: 0,
        // purchaseOrg: 'CNY3',
        orgCode: ''
      },
      trList: [],
      pocmList: [],
      trVer: {
        show: false,
        success: false
      },
      entityVer: {
        show: false,
        success: false
      },
      costVer: {
        show: false,
        success: false
      },
      entityName: '',
      entityList: [],
      quotaList: [],
      quotaDialogVisible: false,
      childCompanyEntityId: ''
    }
  },

  watch: {
    activeBtn () {
      this.trKhCode = ''
      this.queryFrom.trKhCode = ''
      this.queryFrom.quotaId = ''
      this.queryFrom.budget = 0
      this.trVer.show = false
      this.setValue()
    },
    'queryFrom.quotaId' (val) {
      // if (val) {
      // for (let i = 0; i < this.pocmList.length; i++) {
      //   if (this.pocmList[i].quotaId === val) {
      //     this.queryFrom.budget = this.pocmList[i].availableQuota
      //     return
      //   }
      // }
      // }
      // 设置可用预算
      let arr = []
      arr = this.trList.filter(item => {
        return item.quotaId === val
      })
      this.queryFrom.budget = arr.length ? arr[0].availableQuota : 0
    },
    'queryFrom.budget' (val) {
      this.$store.commit('setBudget', val)
    },
    itemType (val) {
      this.queryPocmList()
    },
    orderItemList (val) {
      this.getPocmTrList()
    }
  },

  created () {
    this.getPocmTrList()
    this.queryPocmList()
    this.getEntity()
    this.$store.dispatch('getDictByName', 'purchaseOrgMap')
  },
  methods: {
    setValue () {
      this.$emit('setValue', this.queryFrom)
    },
    // 更改Tr预算
    changeTr (quotaId) {
      let arr = this.trList.filter(item => {
        return item.quotaId === quotaId
      })
      this.queryFrom.trKhCode = arr.length ? arr[0].trKhCode : ''
      this.setValue()
    },

    // 选择工厂信息
    companySelect (val) {
      this.$emit('setCompany', val)
    },

    // 获取pocm预算表
    queryPocmList () {
      let params = {
        quotaType: this.itemType
      }
      if (params.quotaType !== '03') {
        params.quotaType = '01'
      }
      this.$store.dispatch('queryPocmList', params).then(res => {
        if (res.data.resultCode === '0') {
          this.pocmList = res.data.resultData.quotaDetailList || []
        }
      })
    },

    // 工厂
    getEntity () {
      baseApi.getUserCompany().then(res => {
        if (res.data.resultCode === '0') {
          this.entityList = res.data.resultData.companyEntityList
        }
      })
    },

    // 验证tr信息
    getTrInfo () {
      if (!this.trKhCode) {
        this.queryFrom.trKhCode = ''
        this.queryFrom.budget = 0
        this.setValue()
        this.$message.error('请输入TRCode')
        return
      }
      this.trLoading = true
      this.$store.dispatch('getTrInfo', this.trKhCode).then(res => {
        this.trLoading = false
        if (res.data.resultCode === '0') {
          this.trVer.show = true
          if (!res.data.resultData.quotaList) {
            this.$message.error('您暂时无权使用此TRCode')
            this.queryFrom.trKhCode = ''
            this.queryFrom.budget = 0
            this.trVer.success = false
          } else if (res.data.resultData.quotaList.length) {
            this.quotaList = []
            this.quotaList = res.data.resultData.quotaList
            if (this.quotaList.length > 1) {
              this.quotaDialogVisible = true
            } else {
              this.trVer.success = true
              this.queryFrom.trKhCode = this.quotaList[0].trKhCode
              this.queryFrom.orgCode = this.quotaList[0].orgCode
              this.queryFrom.budget = this.quotaList[0].availableQuota
            }
          }
          this.setValue()
        }
      }).catch(() => {
        this.trLoading = false
      })
    },
    // 选配额 多条tr 选择其一
    handleCheckTrCode (row) {
      this.queryFrom.trKhCode = row.trKhCode
      this.queryFrom.orgCode = row.orgCode
      this.queryFrom.budget = row.availableQuota
      this.trVer.success = true
      this.quotaDialogVisible = false
      this.setValue()
    },

    // 验证成本中心
    getCostInfo () {
      if (!this.queryFrom.costCenterCode) {
        this.queryFrom.costCenterId = ''
        this.setValue()
        this.$message.error('请输入成本中心编码')
        return
      }
      let params = {
        costCenterCode: this.queryFrom.costCenterCode,
        entityId: this.companyEntityId || this.childCompanyEntityId
      }
      this.costLoading = true
      this.$store.dispatch('getCostInfo', params).then(res => {
        this.costLoading = false
        if (res.data.resultCode === '0') {
          this.costVer.show = true
          if (!res.data.resultData.baseCostCenter) {
            this.$message.error('无此成本中心')
            this.queryFrom.costCenterId = ''
            this.costVer.success = false
          } else {
            this.costVer.success = true
            this.queryFrom.costCenterId = res.data.resultData.baseCostCenter.costCenterId
          }
          this.setValue()
        }
      }).catch(() => {
        this.costLoading = false
      })
    },

    inputTr () {
      this.trVer.show = false
    },
    // InputEntity () {
    //   this.queryFrom.entityId = ''
    //   this.setValue()
    //   this.entityVer.show = false
    // },
    InputCost () {
      this.queryFrom.costCenterId = ''
      this.setValue()
      this.costVer.show = false
    },

    // 获取品牌
    getSubBrandIds () {
      let arr = []
      this.orderItemList.forEach(item => {
        arr.push(item.subBrandId)
      })
      return arr.join(',')
    },

    // 获取TR预算列表
    getPocmTrList () {
      const params = {
        subBrandIds: this.getSubBrandIds()
      }
      this.$store.dispatch('getPocmTrList', params).then(res => {
        if (res.data.resultCode === '0') {
          this.trList = res.data.resultData.quotaList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  height: 100px;
  line-height: 100px;
  .el-col-10,
  .el-col-21 {
    height: 100%;
    display: flex;
    align-items: center;
    .el-input {
      width: 260px;
    }
    .el-select {
      vertical-align: middle;
      margin-right: $content-large;
      margin-left: -15px;
      width: 180px;
    }
  }
  .input-round {
    margin-right: 10px;
  }
  .iconzu91 {
    font-size: 20px;
    padding-right: 5px;
    vertical-align: middle;
  }
}

.company-select {
  .el-select {
    width: 300px !important;
  }
}

.verif-name {
  position: absolute;
  top: 33px;
}
</style>
